"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var getDueDate = function getDueDate(dueDate) {
  var momentDueDate = (0, _moment.default)(dueDate);
  var parsedDueDate = momentDueDate.isValid() ? momentDueDate : (0, _moment.default)(parseInt(dueDate, 10));
  return parsedDueDate.format(' [Due ] dddd, Do MMMM YYYY hh:mm A');
};

var _default = getDueDate;
exports.default = _default;